import api from '../../api'
import {
  GET_AUCTION_LIST_SUCCESS,
  GET_AUCTION_LIST_FAILURE,
  GET_AUCTION_FAILURE,
  GET_AUCTION_SUCCESS,
  UPDATE_AUCTION_SUCCESS,
} from '../types'
import moment from 'moment';

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {
  getAuctionList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getAuctionList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        commit(GET_AUCTION_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_AUCTION_LIST_SUCCESS, {
        auctionList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.$success)

    }, response => {
      api.stopLoader()
      commit(GET_AUCTION_LIST_FAILURE)
      return reject(response.body.$error)
    })
  })

  },
 
  cleanAuctionList({commit}) {
    return commit(GET_AUCTION_LIST_FAILURE)
  },
  getAuction({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getAuction(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_AUCTION_FAILURE);
            reject();
          }
          commit(GET_AUCTION_SUCCESS, {
            auction: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_AUCTION_FAILURE);
          reject();
        })
    })
  },
 
  
  updateAuction({commit}, data) {
    return new Promise((resolve, reject) => {

      data.deadline = moment.utc(data.date).utcOffset(0).format('DD/MM/YYYY')+" "+data.time

      api.startLoader()
      let avaliables = [
        "id",
        "deadline",
        "initialOffer",
        "CarId"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateAuction(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },


  createAuction({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()

      data.deadline = moment.utc(data.date).utcOffset(0).format('DD/MM/YYYY')+" "+data.time


      api.createAuction(data)
      .then(response => {
        if (!response.ok) {
          api.stopLoader()
          return reject(response.body.$error);
        } else {
          api.stopLoader()
          return resolve(response.body.$success);
        }
      }, response => {
        api.stopLoader()
        return reject(response.body.$error);
      })
    })
  },
  
  
 
  deleteAuction({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteAuction(data)
         .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
    })
  },

  
  
};

const mutations = {

  [UPDATE_AUCTION_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.auction));
  },
  [GET_AUCTION_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_AUCTION_LIST_SUCCESS](state, action) {
    state.list = action.auctionList;
    state.listUpdated = new Date();
  },
  [GET_AUCTION_FAILURE](state) {
    state.selected = null
  },
  [GET_AUCTION_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.auction));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auction.js